import { useQuery } from '@tanstack/react-query';
import { FieldValues } from 'react-hook-form';

import { bookMembershipOptions } from '@/module/Nomen/BookMembership/model/BookMembershipModel';

import { AsyncSelectControl, AsyncSelectControlProps } from '@/core/components';

type BookMembershipSelectControlProps<T extends FieldValues> = Omit<
  AsyncSelectControlProps<T>,
  'isError' | 'isLoading' | 'options'
>;

export function BookMembershipSelectControl<T extends FieldValues>(props: BookMembershipSelectControlProps<T>) {
  const { data, isLoading, isError } = useQuery(bookMembershipOptions.getAll());

  return (
    <AsyncSelectControl
      isError={isError}
      isLoading={isLoading}
      options={data ?? []}
      {...props}
    />
  );
}
